<template>
  <div class="device-param-dialog">
    <custom-dialog
      width="1000px"
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
    >
      <div class="dialog-body">
        <el-form :inline="true" ref="form" label-width="100px" label-position="top">
          <div class="title" v-if="model.data.componentDesc" style="margin-bottom: 18px;">
            <i class="icon icon-tishi"></i>
            {{ model.data.componentDesc }}
          </div>
          <template v-if="classTslGroup.length">
            <el-row :gutter="20" :span="24" v-for="cItem in classTslGroup" :key="cItem.tslId">
              <div class="item-title">
                {{getDicValue('iot_topic_tsl_group',cItem)? `${getDicValue('iot_topic_tsl_group',cItem)}`:'-'}}
              </div>
              <template v-for="(item, index) in paramList">
                <!--
                  widgetType控件类型，1-文本框、2-下拉框、3-复选、4-单选、5-时间控件、6-数字 7-开关等
                  控件是否可编辑，1-可编辑，0-不可编辑
                -->
                <costomWidget
                  v-if="item.topicTslGroup===cItem"
                  :key="index"
                  v-model="item.paramValue"
                  :label='item.dataName'
                  :type="item.widgetType"
                  :isEditWidget='item.isEditWidget'
                  :dicGroup="item.dicGroup"
                  :unit="item.unit"
                  :dataLen="item.dataLen"
                  :dataType="item.dataType"
                  :topicTslGroup="item.topicTslGroup"
                  width="350px"
                >
                </costomWidget>
              </template>
            </el-row>
            <el-row :gutter="20" :span="24" v-if="otherParamList.length>0">
              <template v-for="(item, index) in otherParamList">
                <!--
                  widgetType控件类型，1-文本框、2-下拉框、3-复选、4-单选、5-时间控件、6-数字 7-开关等
                  控件是否可编辑，1-可编辑，0-不可编辑
                -->
                <costomWidget
                  :key="index"
                  v-model="item.paramValue"
                  :label='item.dataName'
                  :type="item.widgetType"
                  :isEditWidget='item.isEditWidget'
                  :dicGroup="item.dicGroup"
                  :unit="item.unit"
                  :dataLen="item.dataLen"
                  :dataType="item.dataType"
                  :topicTslGroup="item.topicTslGroup"
                  width="350px"
                >
                </costomWidget>
              </template>
            </el-row>
          </template>
          <template v-else>
            <el-row :gutter="20" :span="24">
                <!--
                  widgetType控件类型，1-文本框、2-下拉框、3-复选、4-单选、5-时间控件、6-数字 7-开关等
                  控件是否可编辑，1-可编辑，0-不可编辑
                -->
              <costomWidget
                v-for="(item, index) in paramList" :key="index"
                v-model="item.paramValue"
                :label='item.dataName'
                :type="item.widgetType"
                :isEditWidget='item.isEditWidget'
                :dicGroup="item.dicGroup"
                :unit="item.unit"
                :dataLen="item.dataLen"
                :dataType="item.dataType"
                :topicTslGroup="item.topicTslGroup"
                width="350px"
              >
              </costomWidget>
            </el-row>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">
          {{ i18n.com_cancel }}
        </el-button>
        <el-button type="primary" @click="saveParams">
          {{ i18n.com_confirm }}
        </el-button>
        <!-- v-if="componentCode==='configVCUData' || componentCode==='configSN'|| componentCode==='configMCUData'" -->
        <!-- 只有SN VCU 才有 -->
        <el-button  v-if="`${commandMode}`==='6'" type="primary" @click="onSelectHistory">
          {{i18n.page_content_select_historical_data}}
        </el-button>
      </div>
    </custom-dialog>
    <!-- 选择历史  -->
    <history-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="syncHistory"
    >
    </history-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import costomWidget from '@/components/customWidget';
import dialogMixins from '@/mixins/dialog_mixins';
import languageInjectMixins from '@/mixins/language_inject_mixins';
// import historyDialog from './device_param_history_dialog.vue';

export default {
  mixins: [dialogMixins, languageInjectMixins],
  components: {
    costomWidget,
    // historyDialog
  },

  data() {
    return {
      related: false,
      paramList: [],
      // 其他分类
      otherParamList: [],
      iot_tsl_data_unit: {},
      // 用于判断是那个物模型
      componentCode: '',

      dialogVisible: false,
      dialogModel: {},
      tslClass: [],
      classTslGroup: [],
      commandMode: ''

    };
  },
  mounted() {
    this.initDialog();
    this.getDictionary('iot_tsl_data_unit', (data) => {
      this.iot_tsl_data_unit = this.$transformDicValue(data.iot_tsl_data_unit);
    });
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.getParamList();
    },

    getParamList: function () {
      this.$getJSON(apis.serviceModemDeviceData, {
        modemSn: this.model.data.modemSn,
        topicPublishId: this.model.data.topicPublishId,
      }).then((res) => {
        // 默认widgetType是1 输入框  paramValue如果没有默认是空
        res.data.forEach((item) => {
          item.widgetType = item.widgetType || '1';
          item.paramKey = item.tslCode;
          // item.paramValue = item.defaultValue || '';
          if (`${item.widgetType}` === '5' && item.dataValue && item.dataValue.indexOf(':') > -1) {
            // 第一次查配置是:的  下发过是不带冒号的
            // 时间格式不对的话 清空
            // item.paramValue ? item.paramValue
            // 去除冒号  12:00改成1200
            item.paramValue = this.formatHhmmColonStr(item.dataValue) || '';
          } else if (`${item.widgetType}` === '7') {
            // 先取 参数值  后去默认值
            item.paramValue = item.dataValue ? item.dataValue : (item.defaultValue || '0');
          } else if (`${item.widgetType}` === '8') {
            // 日期格式不对的话 清空
            item.paramValue = this.$formateCheckyyyyMMddHHmm(item.dataValue);
          } else {
            // 先取 参数值  后去默认值
            item.paramValue = item.dataValue ? item.dataValue : (item.defaultValue || '');
          }
        });
        this.componentCode = res.data && res.data[0].componentCode || '';
        this.commandMode = this.model.data.commandMode || '';
        this.paramList = res.data.filter(i => i.dataCode !== 'uploadTime');
        this.otherParamList = this.paramList.filter(i => !i.topicTslGroup);
        // 分类topicTslGroup
        this.paramList.forEach((item) => {
          // 如果有分类
          if (item.topicTslGroup && !this.classTslGroup.includes(item.topicTslGroup)) {
            this.classTslGroup.push(item.topicTslGroup);
          }
        });

      });
    },
    // 确认保存菜单
    saveParams: function () {
      // this.$refs.form.validate((valid) => {
      //   if (!valid) {
      //     return;
      //   }
      //   this.saveEditBootCard();
      // });
      this.saveEditParams();
    },
    onSelectHistory: function () {
      this.dialogVisible = true;
      this.dialogModel.title = this.i18n.dialog_title_select_history;
      this.dialogModel.bodyNum = this.model.data.bodyNum;
      this.dialogModel.structureId = this.model.data.structureId;
    },
    // 修改成历史的数据
    syncHistory: function (item) {
      this.paramList.forEach((i) => {
        if ('paramValue' in i) {
          i.paramValue = item[i.dataCode];
        }
      });
    },
    // 保存编辑分组
    saveEditParams: function () {
      // 判断参数不准为空
      // const hasEmpty = this.paramList.find(i => i.paramValue === '');
      // if (hasEmpty) {
      //   const tips = this.i18n.msg_tips_arg_finish;
      //   this.$message.error(tips);
      // } else {
      // VCU数据配置
      if (this.componentCode === 'configVCUData') {
        // 总工作时长
        const totalWorkTime = this.paramList.find(i => i.dataCode === 'totalWorkTime');
        // 客户总工作时长
        const customerWorkTime = this.paramList.find(i => i.dataCode === 'customerWorkTime');
        //
        if (+customerWorkTime.paramValue > +totalWorkTime.paramValue) {
          const tips = this.i18n.msg_tips_client_total_workin_less_than_total_working;
          this.$message.error(tips);
          return;
        }
      }
      // 过滤没有修改的值(现在不需要了)
      // const dataParam = this.paramList.filter(item => item.paramValue !== item.dataValue);
      // 现在全部都要下发
      const dataParam = this.paramList;
      // 如果是二次提交 因为已经赋了修改的值 所以直接赋值当前的参数
      if (dataParam.length < 1) {
        // dataParam = this.paramList;
        const tips = this.i18n.msg_tips_change_param;
        this.$message.error(tips);
        return;
      }
      // // 数据转换
      // dataParam.forEach((i) => {
      //   // 将修改之后的值更新
      //   i.dataValue = i.paramValue;
      //   i.bodyNum = this.model.data.bodyNum;
      //   i.structureId = this.model.data.structureId;
      //   i.componentGroup = this.model.data.componentGroup;
      // });
      this.$postJSON(apis.serviceModemTaskSave, {
        serviceRecordId: this.model.data.serviceRecordId,
        topicPublishId: this.model.data.topicPublishId,
        taskParams: dataParam
      }).then(() => {
        this.$message({
          message: this.i18n.com_handle_success,
          type: 'success'
        });
        this.$emit('success');
        this.closeDialog();
      });
      // }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    }
  }
};
</script>

<style lang="scss">

.device-param-dialog{
  .el-input-group__append{
    background-color: #ffffff;
    padding: 0px 6px;
    font-size: 12px;
  }
  .title {
    padding-left: 10px;
    background: rgba(249, 200, 81, 0.15);
    border-radius: 2px;
    font-size: 12px;
    line-height: 32px;
    color: rgba(108, 117, 125, 1);
    .icon {
      color: rgba(249, 200, 81, 1);
      margin-right: 10px;
    }
  }
}


</style>
